import React from "react";
import { useApp } from "../contexts/AppContext";

// Renders the admin-editable Terms & Conditions or Privacy Policy (PT/EN).
export default function LegalPage({ type }) {
  const { lang, settings } = useApp();
  const isTerms = type === "terms";
  const title = isTerms
    ? (lang !== "en" ? "Termos e Condições" : "Terms & Conditions")
    : (lang !== "en" ? "Política de Privacidade" : "Privacy Policy");
  const content = isTerms
    ? (lang === "en" ? settings.terms_content_en : settings.terms_content_pt)
    : (lang === "en" ? settings.privacy_content_en : settings.privacy_content_pt);

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 pt-10 pb-20" data-testid={`legal-${type}`}>
      <h1 className="font-fredoka text-4xl md:text-5xl font-bold text-[#0B1D3A] mb-6">{title}</h1>
      <div className="rounded-3xl bg-white p-6 md:p-8 border border-[#0B1D3A]/5 shadow-[0_12px_40px_-10px_rgba(11,29,58,0.1)]">
        <div className="font-nunito text-[#0B1D3A]/85 whitespace-pre-wrap leading-relaxed text-[15px]" data-testid={`legal-${type}-content`}>
          {content || (lang !== "en" ? "Conteúdo em breve." : "Content coming soon.")}
        </div>
      </div>
    </div>
  );
}
